import { EdgeRenameChannelRepository } from '@/modules/connect/infra'
import type { RenameChannel } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeRenameChannel(): RenameChannel {
  return new EdgeRenameChannelRepository(makeSupabaseEdgeHttpClient()).execute
}
